import _ from 'lodash';

export const CONDOLENCE_MUTATION_TEMPLATE = _.template(`mutation LegacyApiMutation {
  addCondolence(
    <% _.forEach(filteredSubmission, function(value, key) { %>
      <% if (_.isString(value)) { %>
        <%- key %>: "<%- value %>"
      <% } else { %>
        <%- key %>: <%- value %>
      <% } %>
    <% }); %>
    pictures: [
      <% _.forEach(pictures, function(picture) { %>
        {
          <% _.forEach(picture, function(value, key) { %>
            <% if (_.isString(value)) { %>
              <%- key %>: "<%- value %>"
            <% } else { %>
              <%- key %>: <%- value %>
            <% } %>
          <% }); %>
        }
      <% }); %>
    ]
  ) {
    addCondolenceResponse {
      entryId
    }
  }
}`);

export const PERSON_ALERT_MUTATION_TEMPLATE = _.template(`mutation LegacyApiMutation {
  addPersonAlert(
    personId: "<%=personId%>",
    email: "<%=email%>",
    gbId: <%=guestBookId%>
  ) {
    addAlertResponse {
      alertId
    }
  }
}`);

export const PERSON_UGC_MUTATION_TEMPLATE = _.template(`mutation LegacyApiMutation {
  addCharacteristicAnswer(
    personId: "<%=personId%>",
    obituaryId: "<%=obituaryId%>",
    characteristicCode: "<%=characteristicCode%>",
    answerType: "<%=answerType%>",
    answer: "<%=answer%>"
  ) {
    addCharacteristicAnswerResponse {
      answerId
      characteristicId
    }
  }
}`);

export const LIKES_MUTATION_TEMPLATE = _.template(`mutation LegacyApiMutation {
  incrementCondolenceLike(
    condolenceId: "<%=condolenceId%>"
  ) {
    incrementCondolenceLikeResponse {
      condolenceId
      likes
    }
  }
}`);



// WEBPACK FOOTER //
// ./src/reactModules/redux/templates/mutationTemplates.js